import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const LiberiaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15381'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15381)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M20 0H9.52381V1.86667H20V0ZM20 3.73333H9.52381V5.6H20V3.73333ZM9.52381 7.46667H20V9.33333H9.52381V7.46667ZM20 11.2H0V13.0667H20V11.2Z'
					fill='#E1244A'
				/>
				<rect
					width='9.52381'
					height='9.33333'
					fill='#0C3F8E'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.76144 5.7587L3.08205 6.93195L3.70169 5.00415L2.04414 3.80145L4.10648 3.78325L4.76144 1.8667L5.4164 3.78325L7.47874 3.80145L5.82119 5.00415L6.44083 6.93195L4.76144 5.7587Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default LiberiaFlagIcon;
